/**
 * Envío AP-9 · pedido de exportación armado con el estado del editor EN EL
 * MOMENTO del clic (todas las pistas, textos y stickers).
 *
 * Antes se armaba con listas «memorizadas» por React: si sólo se tocaban las
 * superposiciones, el MP4 salía con las de antes (caso Ep. 01: `carga.mp4`).
 */
import { AUDIO_MODEL_VERSION } from '../../utils/audioModel';
import { ELEMENT_MODEL_VERSION } from '../../utils/overlayModel';

const stripLocal = ({ id, original_duration, thumb_url, label, ...rest }) => rest;
const withTrack = (t) => (c) => ({ ...stripLocal(c), track: t });

/** Fundidos de las transiciones como fade_in / fade_out de los clips vecinos. */
function transitionFades(videoClips, transitions) {
  const byId = new Map(videoClips.map((c) => [c.id, c]));
  const out = new Map();
  const inn = new Map();
  for (const t of transitions || []) {
    const a = byId.get(t.before_id);
    const b = byId.get(t.after_id);
    if (!a || !b) continue;
    // Clips que ya no están pegados: la transición no aplica.
    if (Math.abs((a.start_time + a.duration) - b.start_time) >= 0.02) continue;
    out.set(t.before_id, Math.max(out.get(t.before_id) || 0, t.out_duration));
    inn.set(t.after_id, Math.max(inn.get(t.after_id) || 0, t.in_duration));
  }
  return (c) => ({
    ...c,
    fade_out: Math.max(c.fade_out || 0, out.get(c.id) || 0),
    fade_in: Math.max(c.fade_in || 0, inn.get(c.id) || 0),
  });
}

export function buildRenderPayload(state, { projectId = null } = {}) {
  const s = state;
  const fades = transitionFades(s.videoClips || [], s.videoTransitions);
  return {
    video_tracks: [
      ...(s.videoClips || []).map(fades).map(withTrack('base')),
      ...(s.imageClips || []).map(withTrack('base')),
      ...(s.overlayV1Clips || []).map(withTrack('v1')),
      ...(s.overlayV2Clips || []).map(withTrack('v2')),
    ],
    audio_tracks: (s.audioClips || []).map(stripLocal),
    // Estado sonoro completo: por pista y salida general.
    tracks: s.tracks,
    master_muted: s.masterMuted,
    master_volume: s.masterVolume,
    audio_model_version: AUDIO_MODEL_VERSION,
    // Texto y stickers: el mismo modelo que dibuja el preview.
    elements: s.elements,
    element_model_version: ELEMENT_MODEL_VERSION,
    resolution: s.resolution,
    fps: 30,
    total_duration: typeof s.getTotalDuration === 'function' ? s.getTotalDuration() : 0,
    project_id: projectId || null,
    timeline_version: s.serverVersion,
    // El render apila con el MISMO orden que se ve en el editor.
    track_order: s.trackOrder,
  };
}
